import { useState, useEffect } from "react";

import React from "react";
import { Button, Card, Row, Col } from "react-bootstrap";
import AdminAffiliatesTable from "./AdminAffiliatesTable";
import AdminAffiliatesModal from "./AdminAffiliatesModal";

import axios from "axios";
import Loader from "../../components/Loader";
import { getHostName } from "../../helpers/utils";
import API from "../../api/api";
import { useAuth } from "../../context/AuthContext";
import CustomSearchbar from "../../components/CustomSearchbar";

const AdminAffiliates = () => {
  const { user } = useAuth();

  const hostname = getHostName();

  const [dataList, setDataList] = useState([]);
  const [dataListTmp, setDataListTmp] = useState([]);

  const [loader, setLoader] = React.useState(false);

  const [payload, setPayload] = React.useState({});

  //  modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    API.get("/api/users/get-all")
      .then((res) => {
        console.log(res.data);

        let arr = res.data.data;

        arr = arr.map((user) => {
          let obj = { ...user };

          if (obj.status === "active")
            obj.statusObj = { title: "Active", type: "success" };

          if (obj.status === "inactive")
            obj.statusObj = { title: "Inactive", type: "danger" };

          if (obj.role === "customer")
            obj.roleObj = { title: "Customer", type: "secondary" };

          if (obj.role === "distributor")
            obj.roleObj = { title: "Distributer", type: "info" };

          if (obj.role === "admin")
            obj.roleObj = { title: "Admin", type: "success" };

          if (obj.payment_status === "unpaid")
            obj.payment_status_obj = { title: "Unpaid", type: "warning" };

          if (obj.payment_status === "processing")
            obj.payment_status_obj = { title: "Processing", type: "info" };

          if (obj.payment_status === "paid")
            obj.payment_status_obj = { title: "Paid", type: "success" };

          return obj;
        });
        console.log(arr);

        setDataList(arr);
        setDataListTmp(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const createEntry = () => {
    let obj = {};
    obj.loadType = "Add Affiliate";

    setPayload({ ...obj });
    handleShow();
  };

  const viewEntry = (obj) => {
    obj.loadType = "View Affiliate";

    setPayload({ ...obj });
    handleShow();
  };

  const updateEntry = (obj) => {
    obj.loadType = "Update Affiliate";

    setPayload({ ...obj });
    handleShow();
  };

  const deleteEntry = (obj) => {
    obj.loadType = "Delete Affiliate";

    setPayload({ ...obj });
    handleShow();
  };

  if (loader) {
    return <Loader />;
  } else {
    return (
      <div>
        <Card>
          <Card.Body className="overflow-hidden" style={{ minHeight: "90vh" }}>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className=""
            >
              <h4>Affiliates</h4>

              {user?.role === "admin" && (
                <Button variant="success" size="sm" onClick={createEntry}>
                  + Add
                </Button>
              )}
              {/* <Button variant="success" size="sm" onClick={createEntry}>
                  + Add
                </Button> */}
            </div>
            <Row className="flex-end-center mt-3">
              <Col className=" d-flex justify-content-sm-end">
                <CustomSearchbar
                  searchFlags={[
                    "first_name",
                    "last_name",
                    "email",
                    "city",
                    "phone",
                    "reference_by_code",
                    "referral_code",
                    "user_name",
                    "role",
                    "status"
                  ]}
                  dataListTemp={dataListTmp}
                  stateUpdator={setDataList}
                  placeholders={["name", " email", " code"]}
                />
              </Col>
            </Row>

            <AdminAffiliatesTable
              list={dataList}
              viewEntry={viewEntry}
              updateEntry={updateEntry}
              deleteEntry={deleteEntry}
              user={user}
            />
            <br />

            <AdminAffiliatesModal
              show={show}
              handleClose={handleClose}
              payload={payload}
              setPayload={setPayload}
              getAllData={getDataList}
              hostname={hostname}
              user={user}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
};

export default AdminAffiliates;
